var exports = {
  "Y": "tooltip__XwO6MO",
};

module.exports = exports;
